export function getSmallerMatchOfferViewModel(smallerMatchOffer) {
    const teamSize = Number(smallerMatchOffer?.teamSize);
    const label = Number.isInteger(teamSize) ? `${teamSize}v${teamSize}` : "";
    const status = smallerMatchOffer?.status || null;

    return {
        teamSize,
        label,
        status,
        show:
            Boolean(smallerMatchOffer) &&
            status !== "declined" &&
            Boolean(label),
    };
}

export default getSmallerMatchOfferViewModel;
